import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toPdfPath } from '@demandproai/shared';

// s3 paths of files still queued or mid-upload, so rows can block actions until the upload settles
const usePendingUploadPaths = () => {
    const uploadQueue = useSelector((state) => state.fileUpload?.uploadQueue ?? []);
    const activeUploads = useSelector((state) => state.fileUpload?.activeUploads ?? {});

    return useMemo(() => {
        const pendingUploads = [...uploadQueue, ...Object.values(activeUploads)];
        // some callers persist the raw key while others persist the converted pdf path, so track both
        return new Set(
            pendingUploads.flatMap(({ uniqueKey }) => (uniqueKey ? [uniqueKey, toPdfPath(uniqueKey)] : []))
        );
    }, [uploadQueue, activeUploads]);
};

export default usePendingUploadPaths;
